import { RouteTypeEnum } from '@/api/apis/route';
import { useRouteByType } from '@/queries/route-planner';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';

export const useRouteDetails = (routeType: RouteTypeEnum) => {
  const { logisticsReference } = useBaseCaseDetails();
  const { data: routeData } = useRouteByType(routeType, logisticsReference?.id);

  if (!routeData) {
    throw new Error('No route data provided');
  }

  return routeData;
};
